import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {ReceivablesBalanceService} from "../../../../shared/services/receivables-balance.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UpdateOfwcaDialogData} from "../receivables-balance-update-ofwca/receivables-balance-update-ofwca.component";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

export interface UpdatePartnerFacilityDialogData {
  partnerId: string;
  receivableBalanceId: string;
}

@Component({
  selector: 'app-receivables-balance-update-partner-facility',
  templateUrl: './receivables-balance-update-partner-facility.component.html',
  styleUrls: ['./receivables-balance-update-partner-facility.component.scss']
})
export class ReceivablesBalanceUpdatePartnerFacilityComponent implements OnInit, OnDestroy {


  changePartnerFacilityForm: FormGroup;
  partnerId: string;
  receivableBalanceId: string;
  processingRequest = false;
  enableSaveButton = false;
  partnerFacilityControl: FormControl;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ReceivablesBalanceUpdatePartnerFacilityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdatePartnerFacilityDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private receivablesBalanceService: ReceivablesBalanceService,
    private snack: MatSnackBar,
  ) {
    this.partnerId = data.partnerId;
    this.receivableBalanceId = data.receivableBalanceId;
    this.changePartnerFacilityForm = fb.group({
      partnerFacility: this.partnerFacilityControl = fb.control('',
        [Validators.required]),
    });
  }


  ngOnInit(): void {
    this.changePartnerFacilityForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changePartnerFacilityForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
  sendForm(): void {
    this.processingRequest = true;

    this.receivablesBalanceService.sendUpdatePartnerFacility(this.changePartnerFacilityForm.value, this.receivableBalanceId)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano placówkę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji salda wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
}
